export enum AnalyticsCoupons {
  RETAIL_OFFER = 'RETAIL_OFFER',
  SUBSCRIPTION_OFFER = 'SUBSCRIPTION_OFFER',
  CONNECT_OFFER = 'CONNECT_OFFER',
  DM_OFFER = 'DM_OFFER',
  WINBACK_OFFER = 'WINBACK_OFFER',
  NONE = 'NONE',
  UNKNOWN = 'UNKNOWN',
}
